import React from 'react';
import patron from '../../assests/img/patron.jpg';
import patron2 from '../../assests/img/patron2.jpg';

const PatronMessage = () => {

    return (
        <>
            <div className='inner_top_about_us'>
                <div id="bg" className="data-typography-1 data-theme-1">
                    <div className="page-wraper">
                        <div className="page-content bg-white">
                            <div className="dz-bnr-inr dz-bnr-inr-sm style-1 text-center overlay-primary-dark">
                                <div className="coustom_container">
                                    <div className="dz-bnr-inr-entry">
                                        <div className="pheading">
                                            <h1>Patron Message</h1>
                                        </div>
                                        <nav aria-label="breadcrumb" className="breadcrumb-row">
                                            <ul className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <a href="/">Home</a>
                                                </li>
                                                <li className="mx-2">
                                                    /
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    Patron Message
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>


                            <section className="content-inner section-wrapper5 pt-5 pb-5">
                                <div className="coustom_container">
                                    <div className="row">
                                        <div
                                            className="col-xl-9 col-lg-6 m-b30 wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <div id="pagedata" className="pagedata">
                                                <p>
                                                    <img style={{ paddingLeft: "15px", float: "right" }} src={patron} alt="patron" width="293" height="305" />
                                                    At Karamchand Memorial School we envision education as a powerful instrument for the enlightenment and empowerment of our citizens. It is from this spirit that we draw our educational goal of empowering students to become self-dependent with a global outlook with a keen eye to local conditions.
                                                </p>
                                                <p>
                                                    Our goal is to make KCMS the cradle of leadership and values, from the portals of which will emerge generations of future leaders in every sphere of activity in our country; as indeed in the world of tomorrow.
                                                </p>
                                                <p>
                                                    With this, I optimistically hope that together we, the Management along with the Principal, Teachers, Administrative Staff, our Students and their Parents will work hand-in-hand to realise the targets we have set out for ourselves.
                                                </p>
                                                <p className="mb-4 mb-sm-5">
                                                    <em>
                                                        - Dr. Sunil Sharma
                                                    </em>
                                                </p>

                                                <p>
                                                    <img style={{ paddingRight: "15px", float: "left" }} src={patron2} alt="patron2" width="293" height="305" />
                                                    Education is essentially the process of transformation of an individual to enhance the ability to meet the expected or unexpected situations of life. It is the continuous process of learning. Learning indeed is understanding of new things in a billion ways. Yet to do the things in the best possible way.
                                                </p>
                                                <p>
                                                    According to U.N., there are four pillars of education- learning to know, learning to do, learning to live together and learning to be. At Karamchand Memorial School we are committed to the development of a child as a whole with the emphasis on life skills along with the academics. Each child needs knowledge as well as wisdom. Knowledge comes from books and wisdom originates from inside. Action also is very important as it helps in development of wisdom.
                                                </p>
                                                <p>
                                                    When both the roots are strong then education gives the complete concept of education. For true education, the existence of deep desire, determination, parents and students participation is a must. Our vision is to sow the seed of the above mentioned true education in developing young children. With our deep desire, determination, sincere efforts we are confident that we will be able to create and provide such opportunity at Karamchand Memorial School.
                                                </p>
                                                <p className="mb-4 mb-sm-5">
                                                    <em>
                                                        - Dr. Vandita
                                                    </em>
                                                </p>
                                            </div>
                                        </div>

                                        <div
                                            className="col-xl-3 col-lg-6 wow fadeInUp"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="bg-lgrey">
                                                <div className="subMenubg active">
                                                    <a href="about-us" target="_self" className="submenu">
                                                        About Us
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="our-inspiration"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Our Inspiration
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="history" target="_self" className="submenu">
                                                        History
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a className="submenu">
                                                        Messages
                                                    </a>
                                                    <div className="founder_link">
                                                        <div className="subMenubg">
                                                            <a href="founder-message" className="submenu">
                                                                Founder’s Message
                                                            </a>
                                                        </div>
                                                        <div className="subMenubg">
                                                            <a href="director-message" className="submenu">
                                                                Director’s Message
                                                            </a>
                                                        </div>
                                                        <div className="subMenubg">
                                                            <a href="patron-message" className="submenu">
                                                                Patron Message
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="our-aims" target="_self" className="submenu">
                                                        Our Aims
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="our-ethos"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Our Ethos
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="our-vision.html"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Our Vision
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                        {/* <button className="scroltop icon-up" type="button">
                            <i className="fas fa-arrow-up"></i>
                        </button> */}
                    </div>
                </div>
            </div >
        </>
    )
}

export default PatronMessage;